export const en: Record<string, string> = {
  "projectAgreement.changedWhileEditing": "A new proposal arrived while you were editing. Your draft is saved; review the latest terms before sending.",
  "projectAgreement.awardPending": "The milestone plan is under discussion. The award is finalized when the latest proposal is accepted.",
  "projectAgreement.proposal": "Milestone proposal",
  "projectAgreement.agreedPlan": "Agreed milestone plan",
  "projectAgreement.seeMore": "See more",
  "projectAgreement.seeLess": "See less",
  "projectAgreement.negotiation": "Agreement negotiation",
  "projectAgreement.status.sent": "Sent",
  "projectAgreement.status.superseded": "Replaced",
  "projectAgreement.status.accepted": "Agreed",
  "projectAgreement.status.withdrawn": "Withdrawn",
  "projectAgreement.status.declined": "Declined",
  "projectAgreement.confirmEnd": "End this negotiation? Existing contract terms will stay unchanged. An unawarded project stays under review.",
  "projectAgreement.switchBidder": "To choose a different bidder, withdraw the current proposal first.",
  "projectAgreement.version": "Version",
  "projectAgreement.accept": "Accept proposal",
  "projectAgreement.acceptedTitle": "Proposal accepted",
  "projectAgreement.optionalSignature": "Sign the agreement now, or do it later in Contracts. Funding becomes available after both parties sign.",
  "projectAgreement.signNow": "Sign agreement",
  "projectAgreement.signLater": "Sign later",
  "projectAgreement.continueContract": "Continue to contract",
  "projectAgreement.agreedCompletion": "Agreed completion date",
  "projectAgreement.signatureLoading": "Checking signature status…",
  "projectAgreement.alreadySigned": "You have already signed this agreement. Continue in Contracts to see the next step.",
  "projectAgreement.waitingSignature": "Waiting for the contractor to sign. You can sign afterward in Contracts.",
  "projectAgreement.exactSignature": "Your signature applies to this accepted proposal version.",
  "projectAgreement.signatureChanged": "This agreement has changed or is no longer awaiting signatures. Review the current contract before signing.",
  "projectAgreement.signatureLoadError": "Could not check signature status. Try again or continue to Contracts.",
  "projectAgreement.signatureAccountName": "Account/profile name",
  "projectAgreement.signatureNameMismatch": "Your signature must match your account/profile full name.",
  "projectAgreement.signatureNameRequired": "Enter your full name to sign (at least 2 characters).",
  "projectAgreement.signatureError": "Could not sign. Review the current agreement before trying again.",
  "projectAgreement.sign": "Accept and sign",
  "projectAgreement.counter": "Make an offer",
  "projectAgreement.revise": "Revise proposal",
  "projectAgreement.withdraw": "Withdraw proposal",
  "projectAgreement.decline": "Decline proposal",
  "projectAgreement.declineOffer": "Decline offer",
  "projectAgreement.endContract": "End contract",
  "projectAgreement.keepOffer": "Keep offer",
  "projectAgreement.confirmDeclineOffer": "Decline this offer and end negotiation? The award record will remain. Signing and funding will be unavailable.",
  "projectAgreement.confirmDeclineEngagement": "Decline this offer? Signing and funding will be unavailable.",
  "projectAgreement.declineChanges": "Decline changes",
  "projectAgreement.withdrawChanges": "Withdraw changes",
  "projectAgreement.viewOffer": "View offer",
  "projectAgreement.confirmDeclineChanges": "End this proposed revision? The existing agreed terms will remain in effect.",
  "projectAgreement.offerDeclined": "Offer declined. Negotiation ended; the award record remains.",
  "projectAgreement.waiting": "Waiting for the other party to respond.",
  "projectAgreement.recipient": "Review this proposal. Accept it or suggest a different milestone plan.",
  "projectAgreement.unsigned": "Sending a proposal does not sign the agreement or move money.",
  "projectAgreement.fixed": "The total stays at the agreed bid price.",
  "projectAgreement.send": "Send proposal",
  "projectAgreement.cancel": "Cancel",
  "projectAgreement.add": "Add milestone",
  "projectAgreement.name": "Milestone name",
  "projectAgreement.milestoneActions": "Milestone actions",
  "projectAgreement.amount": "Amount (PHP)",
  "projectAgreement.note": "Message (optional)",
  "projectAgreement.signature": "Your full name as signature",
  "projectAgreement.history": "Proposal history",
  "projectAgreement.view": "View agreement",
  "projectAgreement.messages": "View in Messages",
  "projectAgreement.back": "Back to contracts",
  "projectAgreement.expired": "This proposal expired. Send a fresh revision to continue.",
  "projectAgreement.unavailable": "This agreement is unavailable for negotiation. Its history remains accessible.",
  "projectAgreement.agreed": "Terms agreed. Continue signatures and funding in Contracts.",
  "projectAgreement.ended": "Negotiation ended. Existing contract terms remain unchanged; an unawarded project remains under review.",
  "projectAgreement.changed": "Changes from the previous proposal",
  "projectAgreement.draft": "Draft saved for this browser session.",
  "projectAgreement.remaining": "Remaining to allocate",
  "projectAgreement.total": "Milestone total",
  "projectAgreement.milestones": "Milestones",
  "projectAgreement.confirm": "Confirm decision",
  "projectAgreement.saveError": "Could not send your proposal. Your draft is retained.",
  "projectAgreement.historyError": "Could not load proposal history. Try again.",
  "projectAgreement.refresh": "Review latest proposal",
  "projectAgreement.remove": "Remove milestone",
  "projectAgreement.up": "Move milestone up",
  "projectAgreement.down": "Move milestone down",
  "projectAgreement.proposed": "Proposed completion date",
  "projectAgreement.scope": "Scope and terms",
  "projectAgreement.signHint": "Your signature applies to this exact proposal version. Both parties must sign before funding.",
  "projectAgreement.negotiate": "Negotiate agreement",
  "projectAgreement.contractActions": "Contract actions",
  "projectAgreement.offerDeclinedStatus": "Offer declined",
  "projectAgreement.prepare": "Prepare award offer",
  "projectAgreement.review": "Review proposal",
};

export const tl: Record<string, string> = {
  "projectAgreement.changedWhileEditing": "May bagong panukala habang nag-eedit ka. Naka-save ang draft; suriin muna ang pinakabagong mga tuntunin.",
  "projectAgreement.awardPending": "Pinag-uusapan pa ang plano ng milestones. Magiging pinal ang award kapag tinanggap ang pinakabagong panukala.",
  "projectAgreement.proposal": "Panukalang milestone",
  "projectAgreement.agreedPlan": "Napagkasunduang plano ng milestone",
  "projectAgreement.seeMore": "Tingnan pa",
  "projectAgreement.seeLess": "Tingnan nang mas kaunti",
  "projectAgreement.negotiation": "Negosasyon ng kasunduan",
  "projectAgreement.status.sent": "Naipadala",
  "projectAgreement.status.superseded": "Pinalitan",
  "projectAgreement.status.accepted": "Napagkasunduan",
  "projectAgreement.status.withdrawn": "Binawi",
  "projectAgreement.status.declined": "Tinanggihan",
  "projectAgreement.confirmEnd": "Tapusin ang negosasyon? Mananatili ang dating tuntunin ng kontrata. Susuriin pa rin ang proyektong wala pang award.",
  "projectAgreement.switchBidder": "Bawiin muna ang kasalukuyang panukala upang pumili ng ibang bidder.",
  "projectAgreement.version": "Bersyon",
  "projectAgreement.accept": "Tanggapin ang panukala",
  "projectAgreement.acceptedTitle": "Tinanggap ang panukala",
  "projectAgreement.optionalSignature": "Lagdaan ngayon o sa ibang pagkakataon sa Mga Kontrata. Magiging available ang pagpopondo kapag nakalagda na ang parehong panig.",
  "projectAgreement.signNow": "Lagdaan ang kasunduan",
  "projectAgreement.signLater": "Lagdaan mamaya",
  "projectAgreement.continueContract": "Magpatuloy sa kontrata",
  "projectAgreement.agreedCompletion": "Napagkasunduang petsa ng pagtatapos",
  "projectAgreement.signatureLoading": "Sinusuri ang katayuan ng lagda…",
  "projectAgreement.alreadySigned": "Nalagdaan mo na ang kasunduang ito. Magpatuloy sa Mga Kontrata para sa susunod na hakbang.",
  "projectAgreement.waitingSignature": "Hinihintay ang lagda ng kontratista. Maaari kang lumagda pagkatapos sa Mga Kontrata.",
  "projectAgreement.exactSignature": "Ang lagda mo ay para sa tinanggap na bersyong ito ng panukala.",
  "projectAgreement.signatureChanged": "Nagbago ang kasunduan o hindi na ito naghihintay ng lagda. Suriin ang kasalukuyang kontrata bago lumagda.",
  "projectAgreement.signatureLoadError": "Hindi masuri ang katayuan ng lagda. Subukang muli o magpatuloy sa Mga Kontrata.",
  "projectAgreement.signatureAccountName": "Pangalan sa account/profile",
  "projectAgreement.signatureNameMismatch": "Dapat tumugma ang lagda sa buong pangalan sa iyong account/profile.",
  "projectAgreement.signatureNameRequired": "Ilagay ang buong pangalan para lumagda (hindi bababa sa 2 character).",
  "projectAgreement.signatureError": "Hindi malagdaan. Suriin ang kasalukuyang kasunduan bago subukang muli.",
  "projectAgreement.sign": "Tanggapin at lagdaan",
  "projectAgreement.counter": "Magbigay ng alok",
  "projectAgreement.revise": "Baguhin ang panukala",
  "projectAgreement.withdraw": "Bawiin ang panukala",
  "projectAgreement.decline": "Tanggihan ang panukala",
  "projectAgreement.declineOffer": "Tanggihan ang alok",
  "projectAgreement.endContract": "Tapusin ang kontrata",
  "projectAgreement.keepOffer": "Panatilihin ang alok",
  "projectAgreement.confirmDeclineOffer": "Tanggihan ang alok at tapusin ang negosasyon? Mananatili ang rekord ng award. Hindi na maaaring lumagda o magpondo.",
  "projectAgreement.confirmDeclineEngagement": "Tanggihan ang alok? Hindi na maaaring lumagda o magpondo.",
  "projectAgreement.declineChanges": "Tanggihan ang mga pagbabago",
  "projectAgreement.withdrawChanges": "Bawiin ang mga pagbabago",
  "projectAgreement.viewOffer": "Tingnan ang alok",
  "projectAgreement.confirmDeclineChanges": "Tapusin ang iminungkahing pagbabago? Mananatili ang napagkasunduang tuntunin.",
  "projectAgreement.offerDeclined": "Tinanggihan ang alok. Natapos ang negosasyon; mananatili ang rekord ng award.",
  "projectAgreement.waiting": "Hinihintay ang sagot ng kabilang panig.",
  "projectAgreement.recipient": "Suriin ang panukala. Tanggapin o magmungkahi ng ibang plano.",
  "projectAgreement.unsigned": "Ang pagpapadala ng panukala ay hindi paglagda o pagbabayad.",
  "projectAgreement.fixed": "Nananatili ang kabuuan sa napagkasunduang presyo ng bid.",
  "projectAgreement.send": "Ipadala ang panukala",
  "projectAgreement.cancel": "Kanselahin",
  "projectAgreement.add": "Magdagdag ng milestone",
  "projectAgreement.name": "Pangalan ng milestone",
  "projectAgreement.milestoneActions": "Mga aksyon sa milestone",
  "projectAgreement.amount": "Halaga (PHP)",
  "projectAgreement.note": "Mensahe (opsyonal)",
  "projectAgreement.signature": "Buong pangalan bilang lagda",
  "projectAgreement.history": "Kasaysayan ng mga panukala",
  "projectAgreement.view": "Tingnan ang kasunduan",
  "projectAgreement.messages": "Tingnan sa Mga Mensahe",
  "projectAgreement.back": "Bumalik sa mga kontrata",
  "projectAgreement.expired": "Nag-expire ang panukala. Magpadala ng bagong bersyon upang magpatuloy.",
  "projectAgreement.unavailable": "Hindi magagamit para sa negosasyon. Makikita pa rin ang kasaysayan.",
  "projectAgreement.agreed": "Napagkasunduan ang mga tuntunin. Ituloy ang paglagda at pagpopondo sa Mga Kontrata.",
  "projectAgreement.ended": "Natapos ang negosasyon. Nananatili ang dating tuntunin ng kontrata; sinusuri pa rin ang proyektong wala pang award.",
  "projectAgreement.changed": "Mga pagbabago mula sa nakaraang panukala",
  "projectAgreement.draft": "Naka-save ang draft para sa browser session na ito.",
  "projectAgreement.remaining": "Natitirang ilalaan",
  "projectAgreement.total": "Kabuuan ng milestone",
  "projectAgreement.milestones": "Mga milestone",
  "projectAgreement.confirm": "Kumpirmahin ang pasya",
  "projectAgreement.saveError": "Hindi naipadala. Napanatili ang iyong draft.",
  "projectAgreement.historyError": "Hindi ma-load ang kasaysayan. Subukang muli.",
  "projectAgreement.refresh": "Suriin ang pinakabagong panukala",
  "projectAgreement.remove": "Alisin ang milestone",
  "projectAgreement.up": "Itaas ang milestone",
  "projectAgreement.down": "Ibaba ang milestone",
  "projectAgreement.proposed": "Iminungkahing petsa ng pagkumpleto",
  "projectAgreement.scope": "Saklaw at mga tuntunin",
  "projectAgreement.signHint": "Ang lagda mo ay para sa eksaktong bersyong ito. Dapat lumagda ang parehong panig bago magpondo.",
  "projectAgreement.negotiate": "Makipagnegosasyon",
  "projectAgreement.contractActions": "Mga aksyon sa kontrata",
  "projectAgreement.offerDeclinedStatus": "Tinanggihan ang alok",
  "projectAgreement.prepare": "Ihanda ang alok sa napiling bidder",
  "projectAgreement.review": "Suriin ang panukala",
};
